import { useEffect, useState } from 'react';

import WebApp from '@twa-dev/sdk';

export const useIsOnline = (onChange?: (isOnline: boolean) => void): boolean => {
  const [isActiveWebApp, setIsActiveWebApp] = useState(WebApp.isActive);
  const [isVisibilityVisible, setIsVisibilityVisible] = useState(
    document.visibilityState === 'visible'
  );

  const isOnline = isActiveWebApp && isVisibilityVisible;

  useEffect(() => {
    const updateOnlineState = (nextWebAppActive: boolean, nextVisibility: boolean) => {
      const nextOnline = nextWebAppActive && nextVisibility;

      if (nextOnline !== isOnline) onChange?.(nextOnline);
    };

    const handleActivated = () => {
      const nextWebAppActive = true;
      setIsActiveWebApp(nextWebAppActive);
      updateOnlineState(nextWebAppActive, isVisibilityVisible);
    };

    const handleDeactivated = () => {
      const nextWebAppActive = false;
      setIsActiveWebApp(nextWebAppActive);
      updateOnlineState(nextWebAppActive, isVisibilityVisible);
    };

    const handleVisibilityChange = () => {
      const nextVisibility = document.visibilityState === 'visible';
      setIsVisibilityVisible(nextVisibility);
      updateOnlineState(isActiveWebApp, nextVisibility);
    };

    WebApp.onEvent('activated', handleActivated);
    WebApp.onEvent('deactivated', handleDeactivated);
    window.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      WebApp.offEvent('activated', handleActivated);
      WebApp.offEvent('deactivated', handleDeactivated);
      window.removeEventListener('visibilitychange', handleVisibilityChange);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isActiveWebApp, isVisibilityVisible, onChange]);

  return isOnline;
};
